// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"d920893b","33":"5d78545c","92":"b9af1943","148":"2e65b033","155":"a48f7127","225":"d36dd067","262":"256da314","334":"6351cd60","453":"0e9984c3","589":"24084f65","640":"e27d9d5a","684":"66e15070","826":"a6998e20"}[chunkId] + ".chunk.js";
};